const PALETTE = [
  '#e53935',
  '#8e24aa',
  '#3949ab',
  '#00897b',
  '#f9a825',
  '#ef6c00',
  '#6d4c41',
  '#546e7a',
];

export function colorForEmail(email = '') {
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export function displayNameForEmail(email = '') {
  const local = email.split('@')[0] || email;
  if (!local) {
    return 'User';
  }
  return local.charAt(0).toUpperCase() + local.slice(1);
}

export function initialsForCollaborator(email = '', displayName = '') {
  const name = displayName || displayNameForEmail(email);
  const parts = name
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(/[\s._-]+/)
    .filter(Boolean);

  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  if (parts.length === 1 && parts[0].length >= 2) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return (name[0] || email[0] || '?').toUpperCase();
}
